import { padEnd } from "lodash";

export const RemoveZerosRight = (value: string) => {
    const reverse = value.split('').reverse();
    const tmp = reverse.reduce((acum, char) =>
        char == '0' && acum == '' ? '' : `${acum}${char}`
        , '');
    return padEnd(tmp.split('').reverse().join(''), 2, '0')
}